import React from "react";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { Progress, InfiniteScroll, dialog, Button } from "nq-component";
import withRouter from "../../../withRouter";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import BiometricsPresenter from "./BiometricsPresenter";
import { FloatingForm } from "../../../components/common/Converter";
import FormFactory from "../../../components/FormFactory";
import Hierarchy from "../../../components/common/Hierarchy";
import AssignedUser from "./AssiginedUser/AssignedUser";
import InputFactory from "../../../components/InputFactory";
import { Spin } from "antd";

class BiometricsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new BiometricsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      objects: [],
      object: {},
      isEdit: false,
      hierarchy: {},
      count: 0,
      limit: 50,
      current: 1,
      syncLoading: false,
    };
  }

  getCollectionName() {
    return "biometric_devices";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  handleEditObject(object) {
    this.setState({ object, isEdit: true });
  }

  onChange() {
    this.setState((prevState) => ({
      object: {
        ...prevState.object,
      },
    }));
  }

  async hanldeSubmit() {
    try {
      await upsertUseCase().execute(
        this.getCollectionName(),
        this.state.object,
      );
      this.setState({ isEdit: false });
      this.refetchData();
    } catch (e) {
      console.error(e);
      this.showError(e.message || e);
    }
  }

  tableData(header, data) {
    return (
      <tr>
        <td style={{ backgroundColor: "#d3d3d3", width: "50%" }}>{header}</td>
        <td className="ps-3">{data}</td>
      </tr>
    );
  }

  handleObjectChange(hierarchy) {
    const data = {
      ...this.state.object,
      ...hierarchy,
    };
    // this.setObject(object);
    // this.setState({ hierarchy: data });
    this.setState({ object: { ...data } });
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handleCheckAssignedUser(data) {
    // console.log("DATA: ", data);
    this.setState({ assignedUser: true, device: data });
    // this.navigateTo(`/users/${this.getCollectionName()}/${data.serialNum}`);
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, limit, current } = this.state;
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} System Administration {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center gap-3">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div className="d-flex gap-2">
                      {Object.keys(schema.filters || {}).map((field) => {
                        let { type, ...options } = schema.filters[field];
                        return (
                          <div className="d-flex" key={field}>
                            <InputFactory
                              key={field}
                              type={type}
                              field={field}
                              where={{}}
                              onChange={this.onChangeFilter.bind(this, type)}
                              {...options}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                objectData={this.handleEditObject.bind(this)}
                hrAction={(object) =>
                  this.presenter.actionConfirmation(
                    "reboot",
                    "Are you sure you want to reboot this device? This will temporarily disconnect all users.",
                    object,
                  )
                }
                ofTraining={(object) =>
                  this.presenter.actionConfirmation(
                    "clearLogs",
                    "Are you sure you want to clear all logs on this device? This action cannot be undone.",
                    object,
                  )
                }
                // sync logs
                stepIncrement={(object) =>
                  this.setState({ syncLogs: true, object })
                }
                ofAppearance={(object) =>
                  this.presenter.actionConfirmation(
                    "clearData",
                    "Are you sure you want to clear all data on this device? This action is permanent and cannot be reversed.",
                    object,
                  )
                }
                refetch={this.refetchData.bind(this)}
                printTraining={(data) => this.handleCheckAssignedUser(data)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "biometric",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "acl",
                    "updated",
                    "region",
                    "office",
                    "division",
                    "section",
                    "unit",
                    "cluster",
                  ],
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
          {this.state.isEdit && (
            <FloatingForm width="30rem">
              <CardView style={{ padding: 0 }}>
                <h4 className="fs-6 fw-bold pt-3 ps-3">
                  Add New Biometrics / RFID
                </h4>
                <hr />
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.hanldeSubmit();
                  }}
                >
                  <FormFactory
                    className="ps-3 pe-3 pt-1 pb-1"
                    style={{ fontSize: "14px" }}
                    schema={schema}
                    object={this.state.object}
                    // disabled={true}
                    onChange={this.onChange.bind(this)}
                    excludeFields={[
                      "region",
                      "office",
                      "division",
                      "section",
                      "unit",
                      "cluster",
                    ]}
                  />

                  <div className="row justify-content-center ps-3 pe-3 pt-2 pb-2">
                    <Hierarchy
                      className="mb-2"
                      handleObjectChange={this.handleObjectChange.bind(this)}
                      object={this.state.object}
                    />
                  </div>
                  <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                    <button
                      className="btn btn-light"
                      type="button"
                      onClick={() => {
                        this.setState({ isEdit: false });
                        // this.refetchData();
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      // onClick={this.hanldeSubmit.bind(this)}
                      type="submit"
                    >
                      Register
                    </button>
                  </div>
                </form>
              </CardView>
            </FloatingForm>
          )}
          {/* assigned user  */}
          {this.state.assignedUser && (
            <AssignedUser
              object={this.state.device}
              closeModal={() => this.setState({ assignedUser: false })}
            />
          )}

          {/* sync biometric logs  */}
          {this.state.syncLogs && (
            <FloatingForm width="40rem">
              <CardView>
                <Spin
                  spinning={this.state.syncLoading}
                  tip={
                    this.state.syncLoading
                      ? "Syncing logs... This may take a moment."
                      : undefined
                  }
                >
                  <form
                    className="pe-4 ps-4"
                    onSubmit={(e) => {
                      e.preventDefault();
                      console.log("OBJECT: ", this.state.object);
                      if (this.state.object.stats === "offline") {
                        this.showError(
                          "The device appears to be offline at the moment. Please try again once it reconnects.",
                        );
                        return;
                      }
                      this.presenter.submitBiometricLogSync(
                        this.state.dateRange,
                        this.state.object,
                      );
                    }}
                  >
                    <div className="d-flex gap-2 align-items-center">
                      <i
                        className="bi bi-question-circle"
                        style={{
                          zoom: 2,
                          color: "#faad14",
                        }}
                      />
                      <span className="fw-bold">Sync biometric Logs</span>
                    </div>
                    <span className="fw-bold fs-sm text-muted">
                      Note: This may take about a minute depending on the sync
                      data from the biometric device.
                    </span>

                    <hr />
                    <span className="fs-sm">Sync Range</span>
                    <InputFactory
                      type="Array"
                      _type="DateRange"
                      required={true}
                      defaultValue={this.state.dateRange}
                      field={"dateRange"}
                      onChange={(value, field) =>
                        this.setState({ [field]: value })
                      }
                    />

                    <div className="w-100 d-flex justify-content-end gap-4 m-4 pe-3">
                      <Button
                        type="button"
                        className="btn btn-light fs-sm"
                        onClick={() =>
                          this.setState({ syncLogs: false, syncLoading: false })
                        }
                        disabled={this.state.syncLoading}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        className="btn btn-primary"
                        disabled={this.state.syncLoading}
                      >
                        OK
                      </Button>
                    </div>
                  </form>
                </Spin>
              </CardView>
            </FloatingForm>
          )}
        </div>
      </>
    );
  }
}

export default withRouter(BiometricsPage);
